import classnames from 'classnames';
import React from 'react';

interface Props {
  /**
   * Tailwind geometry only (height, width, rounding), e.g. `'h-x3 w-x20 rounded-full'`. The fill and
   * pulse are owned here so every skeleton stays consistent; callers supply just size and shape.
   */
  className?: string;
}

/**
 * # Skeleton
 *
 * One pulsing placeholder block — the primitive for loading states. Decorative, so it is
 * `aria-hidden`; wrap a group of them in an element with `aria-busy` and an sr-only status for
 * screen readers.
 *
 * ## Usage
 *
 * ```tsx
 * import {Skeleton} from '@albert-io/atomic';
 *
 * <Skeleton className='h-x3 w-x20 rounded-full' />
 * ```
 */
export const Skeleton = ({className}: Props) => (
  <div
    aria-hidden='true'
    className={classnames('animate-pulse-subtle background-bold', className)}
  />
);

export default Skeleton;
